











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {TipoOcorrencia} from '@/model/resource/TipoOcorrencia'
import {TipoOcorrenciaCollection} from '@/model/collection/TipoOcorrenciaCollection'
import {ListTipoOcorrenciaSchema} from '@/schema/resource/TipoOcorrencia/ListTipoOcorrenciaSchema'
import {CsvTipoOcorrenciaSchema} from '@/schema/resource/TipoOcorrencia/CsvTipoOcorrenciaSchema'

@Component
export default class ListTipoOcorrenciaView extends Mixins(MixinQueryRouter) {
  schema = new ListTipoOcorrenciaSchema()
  collection = new TipoOcorrenciaCollection()

  async created() {
    this.collection.perPage = 20
    await this.query()
  }

  goToPersistView(item: TipoOcorrencia) {
    Helper.pushByName('editTipoOcorrencia', item.$id)
  }

  async removeItem(item: TipoOcorrencia) {
    await new DialogRemove(item).confirm(() => item.removeTipoOcorrencia())
    await this.collection.listTipoOcorrencia()
  }

  async downloadXlsx() {
    const {ascending, orderBy, page, limit, ...params} = this.collection.params

    const collection = new TipoOcorrenciaCollection()
      .clearFilters()
      .addFilter(params)

    await collection.listCsvTipoOcorrencia()

    this.$xlsx.downloadFromSchema(
      collection.all(),
      new CsvTipoOcorrenciaSchema(),
      $.t('schema.CsvTipoOcorrencia.title') as string
    )
  }
}
